export const CURRENT_USER = 'Camille Martin';

export function person(name: string) {
  return {
    name,
    initials: name.split(/[\s-]+/).filter(Boolean).slice(0, 2)
      .map((part) => part[0]?.toUpperCase() ?? '').join(''),
  };
}
